import React from 'react'
import {Card, Colors, Icon, P, Row} from '../UI/index.js'
import useAnalyticsStore from '../../stores/AnalyticsStore.js'

interface AnalyticsInsightCardProps {
    title: string
    icon: string
    selected?: boolean
    children: React.ReactNode
    onClick?: () => void
    branding: any
}
/**
 * @param {AnalyticsInsightCardProps} props
 * @returns {React.ReactNode} The rendered AnalyticsInsightCard component
 */
function AnalyticsInsightCard({title, icon, selected, children, onClick, branding}: AnalyticsInsightCardProps): React.ReactNode {
    const {loading} = useAnalyticsStore((state) => state)

    const iconBgColor = (branding && branding.color) || '#3077B6'

    return (
        <Card
            onClick={onClick}
            style={{
                padding: 0,
                overflow: 'auto',
                minHeight: 80,
                cursor: 'pointer',
                background:
                  loading ? 'linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%)' : selected ? Colors.backgroundSelected : Colors.white,
                backgroundSize: loading ? '800px 100px' : '',
                animation: loading ? 'wave-squares 2s infinite ease-out' : ''
            }}
            shadow
        >
            <Row style={{padding: '0 12px', alignItems: 'center', height: '100%'}}>
                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, alignItems: 'center', padding: 0, minWidth: 'auto'}}>
                    <div style={{minWidth: 60, height: 60, backgroundColor: iconBgColor, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Icon style={{fontSize: 32, marginRight: 0, borderRadius: '50%'}} color={Colors.isDarkBackground(iconBgColor) ? 'white' : 'black'} icon={icon} />
                    </div>
                    <P style={{fontWeight: 700, marginLeft: 24, fontSize: 16, wordBreak: 'unset'}}>{title}</P>
                </Row>
                <Row style={{justifyContent: 'center', alignItems: 'center', flex: 1}}>
                    {!loading && children}
                </Row>
            </Row>
        </Card>
    )
}

export default AnalyticsInsightCard
